interface ProgressBarProps {
	value: number;
	total: number;
}

const ProgressBar = ({ value, total }: ProgressBarProps) => {
	const progress = Math.min(Math.max((value / total) * 100, 0), 100);

	return (
		<div className="w-full bg-gray-bg rounded-full h-2">
			<div
				className="bg-blue h-full rounded-full transition-all duration-300"
				style={{ width: `${progress}%` }}
			></div>
		</div>
	);
};

export default ProgressBar;
